import { useState, useEffect } from "react";
import { LandscapeView } from "./LandscapeView";
import { MobileView } from "./MobileView";

export function SearchResultPage() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Update window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {windowWidth > 1024 ? (
        <LandscapeView />
      ) : (
        <MobileView />
      )}
    </div>
  );
}
